import { IS_SERVER_RENDER } from '../../constants';

export const getIsExternalUrl = (url: string) => {
  if (IS_SERVER_RENDER) {
    return false;
  }
  const fullUrl = new URL(url, window.location.href);

  return fullUrl.origin !== window.location.origin;
};
